import { previousLocations } from './historyTracker';

export const shouldCleanup = (payload) => {
  if(previousLocations[1]?.pathname !== payload?.location?.pathname) {
    return true;
  }
  return false;
}